// Vignette du dossier géolocalisé dans la séance de décision : SVG statique (sans WebGL ni fond
// distant), arrondissement du dossier s'il a une limite, sinon la commune, et la position saisie.
import type { Dossier } from '@cc/contrats';
import { PRECISIONS_LOCALISATION } from '@cc/contrats';
import { VignetteCarte } from '@cc/ui';
import { useMemo } from 'react';
import { construireEchelles, fichiersInitiaux, useLimites, useTerritoire } from '../territoire/donnees';
import styles from './decisions.module.css';

export function VignetteDossier({ dossier }: { dossier: Dossier }) {
  const territoire = useTerritoire();
  const { limites, presentation, chargement } = useLimites(fichiersInitiaux(territoire.data));
  const echelles = useMemo(() => (territoire.data && !chargement ? construireEchelles(territoire.data, limites, presentation) : null), [territoire.data, chargement, limites, presentation]);
  const l = dossier.localisation;
  if (!l) return null;
  const t = echelles ? (echelles.echelles.find((e) => e.id === `arrondissement:${dossier.arrondissement?.id ?? ''}` && e.geometrie) ?? echelles.echelles.find((e) => e.id === 'commune')) : null;
  const precision = PRECISIONS_LOCALISATION[l.precision] ?? l.precision;
  return (
    <section className={styles.bloc} aria-label="Localisation du dossier">
      <h3>Localisation</h3>
      <div className={styles.vignette}>
        {t ? <VignetteCarte territoire={t} point={[l.longitude, l.latitude]} libelle={`${t.libelle} : position du dossier (${precision.toLowerCase()})`} largeur={260} hauteur={170} /> : null}
        <p className={styles.sans}>
          {t?.libelle ?? 'Territoire inconnu'}
          {t?.indicatif ? ' (limites indicatives)' : ''} · précision : {precision.toLowerCase()} · {l.latitude.toFixed(5)}, {l.longitude.toFixed(5)}
        </p>
      </div>
    </section>
  );
}
